import {
  FormControlLabel,
  FormHelperText,
  Switch,
  SwitchProps,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type IProps = SwitchProps & {
  name: string;
  label: string;
};

export const SwitchInput = ({ name, label, ...rest }: IProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <>
          <FormControlLabel
            label={label}
            control={
              <Switch
                {...field}
                checked={field.value}
                onChange={e => field.onChange(e.target.checked)}
                {...rest}
              />
            }
          />
          {fieldState.error && (
            <FormHelperText error>{fieldState.error.message}</FormHelperText>
          )}
        </>
      )}
    />
  );
};
